module.exports = __webpack_public_path__ + "static/media/undraw_connected-world_anke.079cf187.svg";